import React from 'react';
import { values } from 'lodash';
import { FallbackState, withInvalidAppState, withErrorBoundary } from '../error-handling';
import TranslationsProvider from '../../context/api-context/translations/translations-provider';
import { useApi } from '../../context/api-context/use-api';
import ConfigurationProvider from '../../context/configuration-context/configuration-provider';
import { isLoggingEnabled } from '../../../common/store/base-params/base-params-selectors';
import { ModalProvider } from '../modals';
import { AppWrapper } from '../app-wrapper/app-wrapper';
import App from '../app/app';
const Root = React.memo((props) => {
    if (useApi(isLoggingEnabled)) {
        console.log('[Comments root props]', props);
    }
    return (React.createElement(TranslationsProvider, { t: props.t },
        React.createElement(ConfigurationProvider, { config: React.useMemo(() => props, 
            // eslint-disable-next-line react-hooks/exhaustive-deps
            values(props)) },
            React.createElement(AppWrapper, null,
                React.createElement(ModalProvider, null,
                    React.createElement(App, null))))));
});
Root.displayName = 'CommentsRoot';
export const WixComments = withErrorBoundary(withInvalidAppState(Root), FallbackState);
//# sourceMappingURL=root.js.map